import './global.css';
import { useState, useRef, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Skeleton, Toast, TextHero, SearchBar } from './polaris.jsx';
import {Login,Dashboard} from "./components/account.jsx";

import {VocabGame} from "./components/vocabGame.jsx";
import {Chat} from "./components/chat.jsx";

import { UserContext } from './providers/UserContext';

function urlBase64ToUint8Array(base64String) {
  try {
    if (!base64String || typeof base64String !== 'string') {
      throw new Error('Invalid base64 string');
    }
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
  } catch (error) {
    console.error('Error converting base64 to Uint8Array:', error);
    throw error;
  }
}

async function requestPermission(users, browser) {
  if (browser === "mac") {
    if (Notification.permission === "granted") alert("Từ vựng sắp được gửi tới cho bạn");
    document.addEventListener("click", () => {
      Notification.requestPermission(); }, { once: true });
    sendTestNotification();
  }
  else if (browser === "pwa"){
    alert("Chúng tôi sẽ cập nhật định kì từ vựng cho bạn iu nhé");
    // Đăng ký service worker (nếu chưa)
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    console.log('🛠 Service worker registered:', registration);

    const publicKey = "BOQWJGRcrngAiviDcWPiRl2_kWWejRA34GKrRHZwZlhJoBj9M_WsqZVMktHtpJAQjcgvwjy0HeqMmdaKzukqc8k";
    
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    console.log('📬 Định danh push subscription:', JSON.stringify(subscription));

    // Gửi subscription đến server
    const response = await fetch('https://api.turbosify.com/api/gpt/remind', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        subscription,
        name: users.name,
        phone: users.phone,
        email: users.email
      })
    });
    console.warn(response)
  }

}

function sendTestNotification() {
  if (!('Notification' in window)) {
    alert("Trình duyệt không hỗ trợ Notification API.");
    return;
  }

  if (Notification.permission === "granted") {
    navigator.serviceWorker.ready.then((reg) => {
      const sw = reg.active || navigator.serviceWorker.controller;
      if (sw) {
        sw.postMessage({
          title: "Thông báo thử nè 🎉",
          body: "Đây là thông báo test từ app bạn",
          icon: "/icon.png"
        });
        console.log("📬 Đã gửi yêu cầu thông báo sang service worker");
      } else {
        alert("⚠️ Không tìm thấy service worker đang active");
      }
    });
  } else if (Notification.permission === "default") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") sendTestNotification();
      else alert("Bạn cần cấp quyền để nhận thông báo.");
    });
  } else {
    alert("Bạn đã từ chối quyền thông báo. Hãy thử bật hoặc liên lạc nhân viên hỗ trợ nhé");
  }
}
function HomePage() {
  const { theme } = useContext(UserContext); // HomePage gets its own theme

  return (
    <div className="min-h-[80vh] flex mx-auto">
      <main className={`max-w-xl mx-auto rounded-xl grid grid-cols-1 gap-6 self-center`}>
        <VocabGame />

        <Link to="/grammar" className="block rounded-xl p-6 cursor-pointer no-underline text-inherit"
          style={{ border: "solid 1px " + theme.textColor }}
        >
          <TextHero color={theme.textColor}>Grammar</TextHero>
        </Link>
        <Link to="/reading" className="block border rounded-xl p-6 border-[#727272] cursor-pointer no-underline text-inherit"
          style={{ border: "solid 1px " + theme.textColor }}
        >
          <TextHero color={theme.textColor}>Reading</TextHero>
        </Link>
        <Link to="/listening" className="block border rounded-xl p-6 border-[#727272] cursor-pointer no-underline text-inherit"
          style={{ border: "solid 1px " + theme.textColor }}
        >
          <TextHero color={theme.textColor}>Listening</TextHero>
        </Link>
      </main>
    </div>
  );
}

function Header({ setDashboard, service }) { // Props needed from App's state
  const { theme, darkMode, users } = useContext(UserContext); // Get theme and darkMode from context
  const [browser,setBrowser] = useState(null)
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("macintosh") && !ua.includes("chrome")) setBrowser('mac')
    if (window.navigator.standalone === true) setBrowser('pwa')
  },[]);

  return <>
  <header className="px-2 py-3 space-x-4 fixed top-0 left-0 w-full" style={{
    backgroundColor: theme.backgroundHeavy,
    color: theme.textColor,
    zIndex:1000
  }}>
    <div className='items-center flex justify-between gap-4 md:grid md:grid-cols-3 mx-auto max-w-[1200px]'>
      <div className='flex items-center space-x-1 md:space-x-2'>
        <Link to="/" className="">
          <Button tone={theme.textColor}>
            <svg fill={darkMode ? theme.textColor : theme.backgroundHeavy} className="w-6 mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.344 3.692a2.25 2.25 0 0 1 3.312 0l3.854 4.19a3.75 3.75 0 0 1 .99 2.538v3.33a2.75 2.75 0 0 1-2.75 2.75h-1.75a1.5 1.5 0 0 1-1.5-1.5v-2h-1v2a1.5 1.5 0 0 1-1.5 1.5h-1.75a2.75 2.75 0 0 1-2.75-2.75v-3.33c0-.94.353-1.847.99-2.539l3.854-4.189Zm2.208 1.016a.75.75 0 0 0-1.104 0l-3.854 4.189a2.25 2.25 0 0 0-.594 1.523v3.33c0 .69.56 1.25 1.25 1.25h1.75v-2a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v2h1.75c.69 0 1.25-.56 1.25-1.25v-3.33a2.25 2.25 0 0 0-.594-1.523l-3.854-4.19Z"/></svg>
          </Button>
        </Link>
        {browser ? (
        <div className="w-[28px]" onClick={() => {
          if(!users) { alert("Bạn cần đăng nhập để nhận thông báo"); return false; }
          else { requestPermission(users,browser); }
        }}>
          <Button tone={theme.textColor}>
              <svg fill={darkMode ? theme.textColor : theme.backgroundHeavy} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.866 4.324c.788-.788 2.134-.23 2.134.884v9.585c0 1.114-1.346 1.672-2.134.884l-2.603-2.603a.25.25 0 0 0-.177-.073h-1.336a1.75 1.75 0 0 1-1.75-1.75v-2.5c0-.967.784-1.75 1.75-1.75h1.336a.25.25 0 0 0 .177-.074l2.603-2.603Zm.634 1.487-2.177 2.177a1.75 1.75 0 0 1-1.237.512h-1.336a.25.25 0 0 0-.25.25v2.5c0 .139.112.25.25.25h1.336c.464 0 .909.185 1.237.513l2.177 2.177v-8.379Z"/><path d="M11.907 7.345a.75.75 0 0 1 1.047-.166 4.152 4.152 0 0 1 .496 6.294.75.75 0 0 1-1.061-1.06 2.65 2.65 0 0 0-.316-4.02.75.75 0 0 1-.166-1.048Z"/><path d="M14.62 4.886a.75.75 0 0 0-.881 1.214 5.486 5.486 0 0 1 .654 8.317.75.75 0 1 0 1.06 1.061 6.986 6.986 0 0 0-.833-10.592Z"/></svg>
          </Button>
        </div>
        ) : null }
      </div>

      <div className="flex items-center space-x-0 md:space-x-4 justify-center">
        {/* <SearchBar textColor={theme.textColor} backgroundColor={theme.backgroundLight}/> */}
      </div>

      <div className="flex items-center space-x-0 md:space-x-4 justify-end">
        <span className="text-sm flex gap-4">
          <span onClick={() => setDashboard(true)} className="relative flex cursor-pointer">
            <svg onClick={() => setDashboard(true)} className="self-center w-6 cursor-pointer" stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 14.0902 3.71255 16.014 4.90798 17.5417C6.55245 15.3889 9.14627 14 12.0645 14C14.9448 14 17.5092 15.3531 19.1565 17.4583C20.313 15.9443 21 14.0524 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 21C9.84977 21 7.87565 20.2459 6.32767 18.9878C7.59352 17.1812 9.69106 16 12.0645 16C14.4084 16 16.4833 17.1521 17.7538 18.9209C16.1939 20.2191 14.1881 21 12 21Z" fill="currentColor"></path></svg>
            <span onClick={() => setDashboard(true)} className="absolute -bottom-1 -right-1 bg-purple-500 hover:bg-purple-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {service}
          </span>
        </span>

        <div className="relative">
          <svg fill={theme.textColor} onClick={(e) => {
            const div = e.currentTarget.parentNode.querySelector("div");
            if (div) {
              if( div.style.display == "grid"){
                div.style.display = "none"
              } else { div.style.display = "grid"}
            } 
          }} className="self-center w-4 h-4 cursor-pointer" stroke="currentColor" stroke-width="0" viewBox="0 0 16 16" id="theme" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"></path></svg>
          <div data="close" style={{display: "none"}} className="absolute right-0 grid grid-cols-1 space-y-1 w-[36px] md:w-[80px] pt-2">
            <Button backgroundColor={theme.backgroundHeavy} textColor={theme.textColor}
              tone={theme.textColor}  click={() => {
              localStorage.setItem('darkMode', 'dark');
              window.location.reload();
            }}>
              Dark
            </Button>
            <Button backgroundColor={theme.backgroundHeavy} textColor={theme.textColor}
              tone={theme.textColor} click={() => {
              localStorage.setItem('darkMode', 'rose');
              window.location.reload();
            }}>
              Rose
            </Button>
            <Button backgroundColor={theme.backgroundHeavy} textColor={theme.textColor}
              tone={theme.textColor} click={() => {
              localStorage.setItem('darkMode', 'light');
              window.location.reload();
            }}>
              Light
            </Button>
          </div>
        </div>

        </span>
      
      </div>

      {/* <Link to="/gpt" className="text-xl font-bold no-underline text-inherit">
        <h1 className="cursor-pointer">
          <span className="text-gray-400">Ngữ pháp như</span><span className="text-white dark:text-black font-bold"> Bản xứ</span>
        </h1>
      </Link> */}
      </div>
    </header>
  </>
}


function App() {
  /*** 
   * Use Context
   * ***/
  const [service,setService] = useState(0)
  const { users, contextloading, darkMode, theme } = useContext(UserContext);

  // useEffect( () => {
  //   if(!users){ setPopup(true);}
  //   else{ 
  //     if(users.service) setService(users.service)
  //     setPopup(false); 
  //   }
  // },[users]);

  useEffect( () => {
    setPopup(false); 
  },[users]);

  /*** 
   * Use Context
   * ***/
  
  /*** 
   * Grammar
   * ***/
  let content = useRef()
  const [corrected,setCorrected] = useState(null)
  /*** 
   * Grammar
   * ***/
  
  /*** 
   * UI State
   * ***/
  const [toast,setToast] = useState(null)
  /*** 
   * UI State
   * ***/
  
  /*** 
   * Link to child component and get their service
   * ***/
  const [popup,setPopup] = useState(false); // login/register
  const [dashboard,setDashboard] = useState(false); // popup user account dashboard
  /*** 
   * Link to child component and get their service
   * ***/


  /***
   * Design 
   * ***/
  const [url, setUrl] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDesignClick = async () => {
    if (!url.trim()) {
      setError("Please enter a valid URL");
      return;
    }

    setLoading(true);
    setError("");
    setImageUrl(null);

    try {
      const response = await fetch("https://api.turbosify.com/api/gpt/design?url=" + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      if (response.ok && data.image_url) {
        setImageUrl(data.image_url);
      } else {
        setError(data.error || "Failed to generate design.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (<>
    { contextloading === true && users ? <>
      <div className="min-h-screen font-sans px-4" style={{ backgroundColor: theme.backgroundLight, color: theme.textColor }}>
        <div className="h-[100px]"/>
          <main className="max-w-xl mx-auto rounded-xl p-6">
            <Skeleton/>
          </main>
      </div>
    </> : 

    <div className="min-h-screen font-sans" style={{ backgroundColor: theme.backgroundLight, color: theme.textColor }}>
      
        <Header setDashboard={setDashboard} service={service}/>

        <div className='h-[100px] md:h-[120px]'/>

        <TextHero color={theme.textColor} size="120px">The art</TextHero>
        <div className='h-[10px]'/>
        <TextHero color={theme.textColor} size="30px">of</TextHero>
        <div className='h-[10px]'/>
        <TextHero color={theme.textColor}>Imagination</TextHero>


        <div className='h-[30px]'/>

        <div className="max-w-xl mx-auto rounded-xl p-4">
          <SearchBar
            backgroundColor={theme.backgroundLight}
            color={theme.textColor}
            placeholder="Paste your website URL here"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            click={handleDesignClick}
            loading={loading}
          />

          {loading && (<>
            <div className="h-[30px]"/>
            <Skeleton/>
            </>
          )}

          {error && (
            <div className="text-red-600 mt-4 text-center">{error}</div>
          )}

          {imageUrl && (
            <div className="mt-6">
              <img src={imageUrl} alt="AI design preview" className="rounded-xl shadow-md" />
            </div>
          )}
        </div>
        
        <Dashboard dashboard={dashboard} darkMode={darkMode} setDashboard={setDashboard} setPopup={setPopup} setService={setService}/>
        
        <div className="max-w-xl mx-auto rounded-xl p-2">
          <Toast status={toast}>{toast}</Toast>
        </div>
        
        <Chat/>

        <div className='h-[30px]'/>
    </div>
    }
  </>);   
}
export default App;